module.exports = __webpack_public_path__ + "img/zztbg-2-en.7b4947da.png";